export default "__VITE_ASSET__cJSfKgYf__"